import React from 'react';

import CategoriesMenuItem from './CategoriesMenuItem';
import css from './CategoriesDesktopMenu.module.css';

const CategoriesDesktopMenu = ({ intl, categories = [] }) => (
  <ul className={css.categoriesDesktopMenu}>
    {categories.map(({ id, name, subcategories }) => (
      <CategoriesMenuItem key={id} {...{ id, name, subcategories, intl }} />
    ))}
  </ul>
);

export default CategoriesDesktopMenu;
